import {BaseTerms} from "../../../../infrastructure/models/base-terms";

export class GameCenterHeaderModuleTerms extends BaseTerms {
  WEB_GC_DAYS = "#NUM Days";
  GAME_TIME_TOMORROW = "Tomorrow";
  WEB_GAME_CENTER_SERIE_NUM = "Series:";
  WEB_GAME_CENTER_BONUS = "Bonus"
}
